import { render, staticRenderFns } from "./HeadFooter.vue?vue&type=template&id=4dec474e&"
import script from "./HeadFooter.vue?vue&type=script&lang=js&"
export * from "./HeadFooter.vue?vue&type=script&lang=js&"
import style0 from "./HeadFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports